import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { USER_ROLE } from '../utils/constants';
import { useStores } from '../hooks/use-stores';

/**
 * Renders children when the user’s effective role matches `requiredRole`.
 * Effective role comes from `store.currentRole`, which already treats the user as a viewer when
 * `resourceViewerMode` or `subscriptionDetailViewerMode` is set (e.g. cross-company view or
 * subscription does not allow LMS edits on a training/assessment detail screen).
 */
function RequireRole({
    children,
    requiredRole = USER_ROLE.ADMIN,
    fallback = null,
}) {
    const { store } = useStores();
    const { currentRole } = store;

    const shouldShow = useMemo(() => {
        const rolesMap = {
            [USER_ROLE.ADMIN]: [USER_ROLE.ADMIN],
            [USER_ROLE.VIEWER]: [USER_ROLE.ADMIN, USER_ROLE.VIEWER],
        };
        return rolesMap[requiredRole].includes(currentRole);
    }, [currentRole, requiredRole]);

    return shouldShow ? <>{children}</> : fallback;
}

export default observer(RequireRole);
